import React from 'react';
import { ArrowRightIcon, TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { pad2 } from './Shared';
export function AnnouncementBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 border-b border-white/10 bg-slate-950/85 backdrop-blur-md" data-id="element-20" data-mp="js915i6dhovl">
      <div className="mx-auto flex h-11 max-w-6xl items-center justify-center gap-3 px-4 text-xs md:text-sm" data-id="element-21" data-mp="euqopht5criu">
        <TimerIcon size={15} className="hidden shrink-0 text-sky-400 sm:block" aria-hidden="true" data-id="element-22" data-mp="9tt8vbvm09ki" />
        <p className="min-w-0 truncate text-slate-300" data-id="element-23" data-mp="5wf1zqveidvo">
          Prix de lancement, fin dans{' '}
          <span className="font-display font-extrabold tabular-nums text-white" data-id="element-24" data-mp="xbwk5bie5n6">
            {pad2(hours)}:{pad2(minutes)}:{pad2(seconds)}
          </span>
        </p>
        <a href="#pricing" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-white/10 px-3 py-1 font-semibold text-white transition-colors duration-150 hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" data-id="element-25" data-mp="1v7xpacvd4txz">
          19&nbsp;€ <ArrowRightIcon size={13} aria-hidden="true" data-id="element-26" data-mp="ab6ii31ldbf2" />
        </a>
      </div>
    </div>;
}